<template>
  <div>
    <div class="mt-2" style="background-color: white; padding: 10px">
      <b-alert variant="success" v-if="success" show>
        {{ success }}</b-alert>
      <b-form @submit.prevent="submitForm" enctype="multipart/form-data">
        <h5>Edit Farm Details</h5>
        <div class="row">
          <div class="col-md-6">
            <b-form-group id="input-group-1" label="Name:" label-for="input-1">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <b-form-input id="input-1" v-model="form.name" type="text" placeholder="Enter Project Name"
                  required></b-form-input>
                <span class="error">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>
            <b-form-group id="input-group-2" label="Code:" label-for="input-2">
              <ValidationProvider v-slot="{ errors }">
                <b-form-input id="input-2" v-model="form.code" placeholder="Enter Project Code" required></b-form-input>
                <span class="error">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>
            <b-form-group id="input-group-2" label="Location:" label-for="input-2">
              <ValidationProvider v-slot="{ errors }">
                <b-form-input id="input-2" v-model="form.location" placeholder="Enter the Address"
                  required></b-form-input>
                <span class="error">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>
            <b-form-group id="input-group-2" label="Google MAP Location URL:" label-for="input-2">
              <ValidationProvider v-slot="{ errors }">
                <b-form-input id="input-2" v-model="form.gmap_location" placeholder="Enter Google MAP Location URL"
                  required></b-form-input>
                <span class="error">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>

            <b-form-group id="input-group-2" label="Description:" label-for="input-2">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <b-form-textarea id="input-2" v-model="form.description" placeholder="Enter description..." rows="5"
                  max-rows="8"></b-form-textarea>
                <span class="error">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>
            <b-form-group id="input-group-2" label="Plot Types:"
              description="please provide the plot type names by comma seperated" label-for="input-2">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <b-form-input id="input-1" v-model="form.plotTypes" type="text" placeholder="Enter Plot Type"
                  required></b-form-input>

                <span class="error">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group id="input-group-2" label="Total area:" label-for="input-2">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <b-form-input id="input-2" type="number" v-model="form.area" placeholder="Enter Total area (In Acres)"
                  required></b-form-input>
                <span class="error">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>

            <b-form-group id="input-group-2" label="Select Organization :" label-for="input-2">
              <ValidationProvider rules="required" v-slot="{ errors }">
                <b-form-select v-model="form._organizationID" value-field="_id" text-field="name">
                  <option value="">Select Organization</option>
                  <option v-for="(option, index) in options" :key="index" :value="option._id">
                    {{ option.name }}
                  </option>
                </b-form-select>
                <span class="error">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>

            <b-form-group id="input-group-2" label="Virtual Tour Link" label-for="input-2">
              <ValidationProvider v-slot="{ errors }">
                <b-form-input id="input-2" v-model="form.virtualTourLink" placeholder="Enter Virtual Tour Link"
                  required></b-form-input>
                <span class="error">{{ errors[0] }}</span>
              </ValidationProvider>
            </b-form-group>


            <b-form-group id="input-group-2" label="Logo:" label-for="input-2">
              <b-form-file id="file" ref="file" v-model="form.image" :state="Boolean(form.image)"
                placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."
                @click="uploadImage"></b-form-file>
              <div class="mt-2">
                <img :src="form.existingImage" alt="Gallery Image"
                  style="max-width: 120px; max-height: 120px; margin-right: 10px;" />
                <button class="btn btn-sm btn-danger" @click="this.form.existingImage == ''" type="button">X</button>

              </div>

            </b-form-group>
            <b-form-group id="input-group-2" label="Display:" label-for="input-2">
              <b-form-radio-group v-model="form.showVirtualTour" :options="virtual_image_link_options" class="mb-3"
                value-field="item" text-field="name" disabled-field="notEnabled"></b-form-radio-group>
            </b-form-group>

            <b-form-group id="input-group-2" label="Farm Visit Allowed:" label-for="input-2">
              <b-form-radio-group v-model="form.isFarmVisitAllowed" :options="farmVisitOptions" class="mb-3"
                value-field="item" text-field="name" disabled-field="notEnabled"></b-form-radio-group>
            </b-form-group>
            <b-form-group id="input-group-2" label="Image Gallery:" label-for="input-2">
              <b-form-file id="gallery" ref="gallery" multiple v-model="form.images" :state="Boolean(form.images)"
                placeholder="Choose a file or drop it here..." drop-placeholder="Drop file here..."
                @change="handleImageUpload"></b-form-file>
              <p v-if="error" class="text-red-500">{{ error }}</p>


              <div style="display: flex;">
                <div v-for="(im, k) in form.existingImages" :key="k" class="mt-2">
                  <img :src="im" alt="Gallery Image" style="max-width: 120px; max-height: 120px; margin-right: 10px;" />
                  <button class="btn btn-sm btn-danger" @click="removeImage(k)" type="button">X</button>
                </div>
              </div>

            </b-form-group>

            <div class="row">
              <div class="col-md-6">
                <h5>Boundaries</h5>
              </div>
              <div class="col-md-6 mb-2 text-right">
                <button class="btn btn-sm btn-primary" type="button" @click="addBoundary">
                  New Boundary
                </button>
              </div>
              <div class="col-md-12">
                <table class="table table-sm">
                  <thead class="small thead-light">
                    <tr>
                      <th>#</th>
                      <th>Latitude</th>
                      <th>Longitude</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(boundary, index) in form.boundaries" :key="index">
                      <td class="small align-middle">
                        {{ index + 1 }}
                      </td>
                      <td>
                        <ValidationProvider rules="required" v-slot="{ errors }">
                          <b-form-input id="input-2" v-model="boundary.latitude" size="sm" placeholder="Enter Latitude"
                            required></b-form-input>
                          <span class="error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </td>
                      <td>
                        <ValidationProvider rules="required" v-slot="{ errors }">
                          <b-form-input id="input-2" v-model="boundary.longitude" size="sm"
                            placeholder="Enter Longitude" required></b-form-input>
                          <span class="error">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </td>
                      <td>
                        <button class="btn btn-sm btn-danger" type="button" @click="removeBoundary(index)">
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <b-button size="sm" variant="success" @click="submitForm()">
              Update
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      farmDetails: "",
      error: '',
      form: {
        name: "",
        code: "",
        description: "",
        area: "",
        _organizationID: "",
        image: "",
        gmap_location: "",
        location: "",
        boundaries: [],
        showVirtualTour: true,
        virtualTourLink: "",
        plotTypes: "",
        isFarmVisitAllowed: false,
        images: [],
        existingImage: "",
        existingImages: []
      },
      
      options: [],
      virtual_image_link_options: [
        { item: true, name: "Virtual Tour" },
        { item: false, name: "Image" },
      ],
      farmVisitOptions: [
        { item: true, name: "Yes" },
        { item: false, name: "No" },
      ],
      success: false,
    };
  },
  mounted() {
    this.getFarmDetails();
    this.getOrganization();
  },
  methods: {
    getFarmDetails() {
      let farmID = this.$route.params.id;
      window.axios.get("/project/" + farmID, {}).then((resp) => {
        console.log(resp.data.success);
        if (resp.data.success) {
          let data = resp.data.data;
          this.form.name = data.name;
          this.form.code = data.code;
          this.form.description = data.description;
          this.form.area = data.area;
          this.form._organizationID = data._organizationID;


          this.form.gmap_location = data.gmap_location;
          this.form.location = data.location;
          this.form.boundaries = data.boundaries;
          this.form.showVirtualTour = data.showVirtualTour;
          this.form.virtualTourLink = data.virtualTourLink;
          this.form.isFarmVisitAllowed = data.isFarmVisitAllowed;


          this.form.existingImages = data.images;
          this.form.existingImage = data.image;

          this.form.plotTypes = data.plotTypes.toString()
        }
      });
    },
    getOrganization() {
      window.axios.get("organization").then((resp) => {
        if (resp.data.success) {
          console.log(resp.data.data);
          this.options.push(resp.data.data);
        } else {
          alert(resp.data.message);
        }
      });
    },
    submitForm() {
      let farmID = this.$route.params.id;

      let formData = new FormData();
      formData.append("code", this.form.code);
      formData.append("name", this.form.name);
      formData.append("description", this.form.description);
      formData.append("area", this.form.area);
      formData.append("gmap_location", this.form.gmap_location);
      formData.append("location", this.form.location);
      formData.append("_organizationID", this.form._organizationID);
      formData.append("showVirtualTour", this.form.showVirtualTour.toString());
      formData.append("virtualTourLink", this.form.virtualTourLink);
      formData.append("plotTypes", this.form.plotTypes);
      formData.append("isFarmVisitAllowed", this.form.isFarmVisitAllowed.toString());
      formData.append(
        "boundaries",
        JSON.stringify(this.form.boundaries)
      );
      formData.append(
        "existingImages",
        JSON.stringify(this.form.existingImages)
      );
      formData.append(
        "existingImage",
        this.form.existingImage
      );

      if (this.form.image) {
        formData.append("image", this.form.image);
      }

      this.form.images.forEach(file => {
        formData.append('images', file);
      });
      window
        .axios({
          method: "put",
          url: "project/" + farmID,
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((resp) => {
          console.log(resp);
          if (resp.data.success) {
            this.success = resp.data.message;
            this.$emit("project-create", resp.data);
          }
          setTimeout(
            () => (
              (this.success = false), this.$router.push("/projects")
            ),
            3000
          );
        });
    },
    addBoundary() {
      this.form.boundaries.push({
        latitude: "",
        longitude: "",
      });
    },
    removeBoundary(index) {
      this.form.boundaries.splice(index, 1);
    },
    uploadImage() {
      this.form.image = this.$refs.file.files[0];
    },
    removeImage(index) {
      this.form.existingImages.splice(index, 1);
    },
    handleImageUpload(event) {
      const newFiles = Array.from(event.target.files);
      this.error = '';

      const existingCount = this.form.existingImages?.length || 0;
      const totalCount = existingCount + newFiles.length;

      if (totalCount > 4) {
        this.error = `You can upload a maximum of 4 images (including existing ones). You already have ${existingCount}.`;
        this.form.images = [];
        return;
      }

      const oversized = newFiles.filter(file => file.size > 5 * 1024 * 1024); // 5MB

      if (oversized.length > 0) {
        this.error = 'Each image must be smaller than 5MB.';
        this.form.images = [];
        return;
      }

      this.form.images = newFiles;
    }

  },
};
</script>
<style>
.text-red-500 {
  color: red;
  font-weight: 500;
}
</style>